// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDocumentsWithRelationshipsMutationVariables = Types.Exact<{
  input: Array<Types.CreateDocumentWithEntityRelationshipsInput> | Types.CreateDocumentWithEntityRelationshipsInput;
}>;


export type CreateDocumentsWithRelationshipsMutation = { __typename?: 'Mutation', createDocumentsWithEntityRelationships: Array<{ __typename?: 'Document', id: string, name: string, type: Types.DocumentType, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, entity?: { __typename?: 'Entity', id: string } | null } | null } | null> | null } }> };

export const Operations = {
  Mutation: {
    CreateDocumentsWithRelationships: 'CreateDocumentsWithRelationships' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateDocumentsWithRelationshipsDocument = gql`
    mutation CreateDocumentsWithRelationships($input: [CreateDocumentWithEntityRelationshipsInput!]!) {
  createDocumentsWithEntityRelationships(input: $input) {
    id
    name
    type
    entityDocumentRelationships {
      edges {
        node {
          id
          relationshipType
          entity {
            id
          }
        }
      }
    }
  }
}
    `;
export type CreateDocumentsWithRelationshipsMutationFn = Apollo.MutationFunction<CreateDocumentsWithRelationshipsMutation, CreateDocumentsWithRelationshipsMutationVariables>;

/**
 * __useCreateDocumentsWithRelationshipsMutation__
 *
 * To run a mutation, you first call `useCreateDocumentsWithRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentsWithRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentsWithRelationshipsMutation, { data, loading, error }] = useCreateDocumentsWithRelationshipsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentsWithRelationshipsMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentsWithRelationshipsMutation, CreateDocumentsWithRelationshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentsWithRelationshipsMutation, CreateDocumentsWithRelationshipsMutationVariables>(CreateDocumentsWithRelationshipsDocument, options);
      }
export type CreateDocumentsWithRelationshipsMutationHookResult = ReturnType<typeof useCreateDocumentsWithRelationshipsMutation>;
export type CreateDocumentsWithRelationshipsMutationResult = Apollo.MutationResult<CreateDocumentsWithRelationshipsMutation>;
export type CreateDocumentsWithRelationshipsMutationOptions = Apollo.BaseMutationOptions<CreateDocumentsWithRelationshipsMutation, CreateDocumentsWithRelationshipsMutationVariables>;